import { Grid, Typography } from "@material-ui/core";
import { useOktaAuth } from "@okta/okta-react";
import { Copyright } from "components/Copyright/Copyright";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { SignInForm } from "components/SignInForm/SignInForm";
import React from "react";
import { Redirect } from "react-router-dom";
import { loginStyles } from "./LoginStyles";

// TODO: improve layout and appearance on different screen sizes
export function Login() {
    const { authState } = useOktaAuth();

    const classes = loginStyles();

    if (!authState) {
        return (
            <div className={classes.indicatorContainer}>
                <LoadingIndicator />
            </div>
        );
    }

    if (authState.isAuthenticated) {
        return <Redirect to="/" />;
    }

    return (
        <Grid container className={classes.root}>
            <Grid item xs className={classes.sideImage} />
            <Grid item xs={6}>
                <div className={classes.formContainer}>
                    <img
                        src="/images/Logo.png"
                        alt="logo"
                        className={classes.logo}
                    />

                    <Typography
                        variant="h1"
                        align="center"
                        className={classes.title}
                        style={{ fontFamily: "canada-type-gibson" }}
                    >
                        Marvel
                    </Typography>

                    <SignInForm />
                    <Copyright className={classes.copyright} />
                </div>
            </Grid>
        </Grid>
    );
}
